import { IProduct } from "../../entities/product/types";
import ProductAdaptee from "./ProductAdaptee";
import { IAdapter } from "./types";

class ProductAdapter implements IAdapter {

  private readonly adaptee: ProductAdaptee;
  private readonly product: IProduct;

  constructor(product: IProduct, adaptee: ProductAdaptee) {
    this.adaptee = adaptee;
    this.product = product;
  }

  transform() {
    return this.adaptee.transform(this.product);
  }

}

export default ProductAdapter;
